import { useTranslation } from "react-i18next";
import type { ConflictLevel } from "../../../api/content/reviewDecoders";
import Chip from "../../../ui/feedback/Chip";
import type { ChipTone } from "../../../ui/styles/chipStyles";

const LEVEL_TONE: Readonly<Record<ConflictLevel, ChipTone>> = {
  conflict: "danger",
  check: "warning",
  info: "info",
};

/** A conflict level (requirements §6.10): conflict, check or info. */
export default function ConflictLevelBadge({ level }: { level: ConflictLevel }) {
  const { t } = useTranslation();
  return <Chip tone={LEVEL_TONE[level]}>{t(`reviews.levels.${level}`)}</Chip>;
}
